<tax-cto-detail-header
  [contract]="contract"
  [componentTitle]="'menu.cto'"
  (contractUpdated)="getContract(contractId)"
></tax-cto-detail-header>

<tax-input
  data-qa-input="search"
  (input)="searchFieldChange($event)"
  [(ngModel)]="searchCriteria"
  placeholder="retail.place.placeholder"
></tax-input>

<div class="ui-kit-tag-list" data-qa-block="tag-list">
  <div
    class="ui-kit-tag"
    tabindex="0"
    [ngClass]="{ tag__selected: isTagSelected(tag.key) }"
    *ngFor="let tag of tags | keyvalue"
    (click)="selectTag(tag.key)"
    [attr.data-qa-tag]="tag.key"
  >
    <span translate data-qa="tag-name">{{ tag.key }}</span>
    <span class="ui-kit-tag__counter" data-qa="tag-counter">{{ tag.value }}</span>
  </div>
</div>

<ng-container *ngFor="let rp of retailPlaces">
  <tax-cto-retail-place [retailPlace]="rp" [contract]="contract"></tax-cto-retail-place>
</ng-container>
<div *ngIf="!isFullLoaded" class="load_more_block">
  <button class="load_more_block__button" (click)="loadMore()" data-qa-button="load-more">
    <span class="load_more_block__button_text" translate data-qa="load-more-text"
      >cto.details.load.more</span
    >
  </button>
</div>

<ng-template [ngIf]="!retailPlaces?.length">
  <div class="empty_card" translate data-qa-block="empty-list">
    <span translate data-qa="empty-list-text">cto.details.empty.list</span>
  </div>
</ng-template>
